'use strict';

export default angular
  .module('maestro.services.google-maps-service', [])
  .service('GoogleMapsService', function(
    $q,
    I18nService,
    webcore
  ) {
    let googleMapsApiKey;
    let googleMapsUrl;

    this.getGoogleMapsApiKey = () => {
      if (googleMapsApiKey) {
        return $q.when(googleMapsApiKey);
      }

      if (process.env.GOOGLE_MAPS_API_KEY) {
        googleMapsApiKey = process.env.GOOGLE_MAPS_API_KEY;
        return $q.when(googleMapsApiKey);
      }

      return $q.when(webcore.services.systemProperties.getGoogleMapsKey())
        .then((key) => {
          googleMapsApiKey = key;
          return key;
        });
    };

    this.getGoogleMapsUrl = () => {
      return this.getGoogleMapsApiKey()
        .then(key => {
          googleMapsUrl = `https://maps.google.com/maps/api/js?libraries=places&loading=async`;
          if (key) {
            googleMapsUrl += `&key=${encodeURIComponent(key)}`;
          }

          let selectedLng = I18nService.getLocale();
          if (selectedLng && selectedLng.name) {
            googleMapsUrl += `&language=${encodeURIComponent(selectedLng.name)}`;
          }
          return googleMapsUrl;
        });
    };

    return this;
  })

  .name;
